import { useState } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import NftDashboard from "./scenes/configuredApps";
import Configure from "./scenes/configuredApps/configure";
import SelectApp from "./scenes/nftTokenGatingData";
import TestConfig from "./scenes/testConfiguration";
import TokenGatingInputData from "./scenes/nftTokenGatingData/components/index.jsx";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import ProtectedRouteForLogin from "./protectedRoutes/protectedRouteForLogin";
import ProtectedRouteForDashboard from "./protectedRoutes/protectedRouteForDashboard";
import GoogleDrive from "./scenes/googleDrive";
import GoogleDriveCallback from "./scenes/googleDrive/callback";
import GrantAccess from "./scenes/googleDrive/grantAccess";
import Form from "./scenes/googleDrive/tokenGatingForm";
import Login from "./loginComponents/Login";
import LoginCallback from "./loginComponents/loginCallback";
import Register from "./loginComponents/Register";
import DiscordCallback from "./scenes/discord/callback";
import DiscordForm from "./scenes/discord/discordForm";
import Discord from "./scenes/discord";
import DiscordGrantAccess from "./scenes/discord/grantAccess";
import Circle from "./scenes/circle";
import CircleForm from "./scenes/circle/circleForm";
import CircleGrantAccess from "./scenes/circle/grantAccess";
import SupportForm from "./scenes/supportForm";
import NftMinting from "./scenes/nftMinting";
import NftCollectionForm from "./scenes/nftMinting/NftCollectionForm";
import NftCollectionDetail from "./scenes/nftMinting/NftCollectionDetailPage";
import NftMintForm from "./scenes/nftMinting/NftMintForm";
import NftMintingCustomizationPage from "./scenes/nftMinting/NftMintingCustomizationPage";
import Skool from "./scenes/skool";
import SkoolForm from "./scenes/skool/tokenGatingForm";
import SkoolGrantAccess from "./scenes/skool/SkoolGrantAccess";
import CalendlyTokenGatingDetails from "./scenes/calendly/index.jsx";
import CalendlyEdit from "./scenes/configuredApps/calendlyEdit";
import DiscourseTokenGatingDetails from "./scenes/discourse/index.jsx";
import DiscourseEdit from "./scenes/configuredApps/discourseEdit";
import DiscourseConnectSSOPage from "./scenes/discourseConnect/index.jsx";
import ZoomTokenGatingInputData from "./scenes/zoom/index.jsx";
import ZoomEdit from "./scenes/configuredApps/zoomEdit";
import NftMarketplace from "./scenes/nftMarketplace";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const SidebarLayout = () => (
    <>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <div className="app">
            <Sidebar isSidebar={isSidebar} />
            <main
              style={{ backgroundColor: "rgb(249, 251, 250)" }}
              className="content"
            >
              <Topbar setIsSidebar={setIsSidebar} />
              <Outlet />
            </main>
          </div>
        </ThemeProvider>
      </ColorModeContext.Provider>
    </>
  );

  return (
    <Routes>
      <Route
        path="/token-gating/google-drive/grant-access"
        element={<GrantAccess />}
      />
      <Route
        path="/token-gating/discord/grant-access"
        element={<DiscordGrantAccess />}
      />
      <Route
        path="/token-gating/circle/grant-access"
        element={<CircleGrantAccess />}
      />
      <Route
        path="/token-gating/skool/grant-access"
        element={<SkoolGrantAccess />}
      />
      <Route exact path="/login/callback" element={<LoginCallback />} />
      <Route
        path="/discourse-sso-connect"
        element={<DiscourseConnectSSOPage />}
      />
      <Route element={<ProtectedRouteForLogin />}>
        <Route exact path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="*" element={<Login />} />
      </Route>

      <Route element={<ProtectedRouteForDashboard />}>
        <Route element={<SidebarLayout />}>
          <Route path="/token-gating">
            <Route index element={<SelectApp />} />
            <Route path="customization" element={<TokenGatingInputData />} />
            <Route path="google-drive">
              <Route index element={<GoogleDrive />} />
              <Route path="callback" element={<GoogleDriveCallback />} />
              <Route path="configuration" element={<Form />} />
            </Route>
            <Route path="discord">
              <Route index element={<Discord />} />
              <Route path="callback" element={<DiscordCallback />} />
              <Route path="configuration" element={<DiscordForm />} />
            </Route>
            <Route path="calendly" element={<CalendlyTokenGatingDetails />} />
            <Route path="zoom" element={<ZoomTokenGatingInputData />} />
            <Route path="discourse" element={<DiscourseTokenGatingDetails />} />
            <Route path="circle">
              <Route index element={<Circle />} />
              <Route path="configuration" element={<CircleForm />} />
            </Route>
            <Route path="skool">
              <Route index element={<Skool />} />
              <Route path="configuration" element={<SkoolForm />} />
            </Route>
          </Route>
          <Route path="/test-configuration">
            <Route index element={<TestConfig />} />
          </Route>
          <Route path="/configured-apps">
            <Route index element={<NftDashboard />} />
            <Route path="configure" element={<Configure />} />
            <Route path="calendly-edit" element={<CalendlyEdit />} />
            <Route path="discourse-edit" element={<DiscourseEdit />} />
            <Route path="zoom-edit" element={<ZoomEdit />} />
          </Route>
          <Route path="/contact-us" element={<SupportForm />} />
          <Route path="/nft-minting">
            <Route index element={<NftMinting />} />
            <Route path="add-collection" element={<NftCollectionForm />} />
            <Route path="edit-collection/:id" element={<NftCollectionForm />} />
            <Route
              path="collection-detail/:id"
              element={<NftCollectionDetail />}
            />
            <Route
              path="collection-detail/:id/add-nft"
              element={<NftMintForm />}
            />
            <Route
              path="collection-detail/:id/edit-nft"
              element={<NftMintForm />}
            />
            <Route
              path="collection-detail/:id/custom-page"
              element={<NftMintingCustomizationPage />}
            />
          </Route>
          <Route path="/nft-marketplace">
            <Route index element={<NftMarketplace />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
